import type { PropsWithChildren } from "react";

import cn from "../../utils/cn.util";

export type CardActionsProps = {
  className?: string;
} & PropsWithChildren;

export const Actions = ({ children, className }: CardActionsProps) => {
  return <div className={cn("flex items-center gap-2 justify-self-end", className)}>{children}</div>;
};
